var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1045_1965)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00065 11.8335C8.27679 11.8335 8.50065 11.6096 8.50065 11.3335V7.3335C8.50065 7.05735 8.27679 6.8335 8.00065 6.8335C7.72451 6.8335 7.50065 7.05735 7.50065 7.3335V11.3335C7.50065 11.6096 7.72451 11.8335 8.00065 11.8335Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00065 4.66683C8.36884 4.66683 8.66732 4.96531 8.66732 5.3335C8.66732 5.70169 8.36884 6.00016 8.00065 6.00016C7.63246 6.00016 7.33398 5.70169 7.33398 5.3335C7.33398 4.96531 7.63246 4.66683 8.00065 4.66683Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.833984 8.00016C0.833984 4.04212 4.04261 0.833496 8.00065 0.833496C11.9587 0.833496 15.1673 4.04212 15.1673 8.00016C15.1673 11.9582 11.9587 15.1668 8.00065 15.1668C4.04261 15.1668 0.833984 11.9582 0.833984 8.00016ZM8.00065 1.8335C4.5949 1.8335 1.83398 4.59441 1.83398 8.00016C1.83398 11.4059 4.5949 14.1668 8.00065 14.1668C11.4064 14.1668 14.1673 11.4059 14.1673 8.00016C14.1673 4.59441 11.4064 1.8335 8.00065 1.8335Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1045_1965"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/InfoCircle.9fe236db851713f2539cfb5b756833c3.svg";
export { ForwardRef as ReactComponent };